<template>
    <div class="buy-now-confirmation-onboarding">
        <h2>Order Details</h2>
        <p class="coffee-name-sm">{{ order.coffeeName }}</p>
        <div class="confirmation-content-wrapper">
            <div>
                {{ humanizeGrind(order.grind, true) }}
                <span v-if="order.isSampler">{{ order.displaySize }} bag</span>
                <span v-else>{{ order.qty }} &times; {{ order.displaySize }} bag</span>
            </div>
            <p>Est. Delivery: {{ getEta() }}</p>
            <p class="font-green">Standard Price: {{formatPrice(order.unitPrice)}}</p>
            <!-- <div v-if="orderPreferences.subscribe">
                <p class="font-green">Half off on your 1st order</p>
                <h2 class="total-price">Total: {{ formatPrice(order.unitPrice/2) }}</h2>
            </div> -->
            <!-- <div v-else> -->
                <div v-if="sizeCategory === 'small_size'">
                    <p class="font-green">- $5 Welcome Discount</p>
                    <h2 class="total-price">Total: {{ formatPrice(order.unitPrice - 500) }}</h2>
                </div>
                <div v-else-if="sizeCategory === 'medium_size'">
                    <p class="font-green">- $10 Welcome Discount</p>
                    <h2 class="total-price">Total: {{ formatPrice(order.unitPrice - 1000) }}</h2>
                </div>
                <div v-else-if="sizeCategory === 'large_size'">
                    <p class="font-green">- $20 Welcome Discount</p>
                    <h2 class="total-price">Total: {{ formatPrice(order.unitPrice - 2000) }}</h2>
                </div>                
            <!-- </div> -->
        </div>

        <template v-if="orderPreferences.subscribe">
            <h2>Subscription Details</h2>
            <div class="order-preferences">
                <div class="order-preference">{{ humanizeGrind(orderPreferences.grind) }}</div>
                <div class="order-preference-size">
                    <div v-for="sizeName in orderPreferences.size" class="order-preference">{{ sizeName }}</div>
                </div>
                <div class="order-preference">{{ humanizeString(convertCoffeeType(orderPreferences.type)) }}</div>
                <div class="order-preference-last">{{ humanizeString(orderPreferences.frequency) }}</div>
            </div>
        </template>

        <button @click="confirm()" class="btn-green-lg">
            <div v-if="processing" class="spinner">
                &nbsp
            </div>
            <span v-else>
                {{ orderPreferences.subscribe ? 'Checkout & Subscribe' : 'Checkout' }}
            </span>
        </button>

        <fieldset class="margin-top-sm">
            <input type="checkbox" id="newsletter" v-model="subscribeNewsLetter">
            <label for="newsletter" class="checkbox-label font-sm">Join our newsletter for a chance to win free coffee every week!</label>
        </fieldset>
    </div>
</template>

<script>
    import CommonMixin from "../../../mixins/common-mixin"
    import CoffeeMixin from "../../../mixins/coffee-mixin";
    import DateMixin from "../../../mixins/date-mixin";

    export default {
        mixins: [
            CommonMixin,
            CoffeeMixin,
            DateMixin
        ],
        props: {
            hasShippingAndBillingDetails: Boolean,
            order: Object,
            orderPreferences: Object,
            address: Object,
            name: String,
            isGift: Boolean,
            taxRate: Number,
            signUpOnly: Boolean,
            customSizes: Array
        },
        data: function() {
            return  {
                processing: false,
                bagImgLoaded: false,
                subscribeNewsLetter: true,
                sizeCategory: undefined
            }
        },
        methods: {
            confirm() {
                if (this.processing) {
                    return;
                }
                this.processing = true;
                this.$emit('confirmed');
            },
            getEta() {
                const minDeliveryDays = 6;
                const maxDeliveryDays = 8;
                let range_min = new Date();
                let range_max = new Date();
                range_min.setDate(range_min.getDate() + minDeliveryDays);
                range_max.setDate(range_max.getDate() + maxDeliveryDays);
                return `${this.formatDateWithoutYear(range_min)} - ${this.formatDateWithoutYear(range_max)}`;
            },
            convertCoffeeType(type) {
                if (type === 'regular')
                    return 'no decaf';
                return type;
            }
        },
        computed: {
            creditUsed: function () {
                if (!this.applicableCreditAmountCents || !this.applicableCreditAmountCents > 0 ) {
                    return 0
                }
                return this.applicableCreditAmountCents > this.order.totalPrice ? this.order.totalPrice : this.applicableCreditAmountCents;
            },
            chargedAmount: function () {
                if (!this.applicableCreditAmountCents) {
                    return this.order.totalPrice;
                }

                if (this.applicableCreditAmountCents > this.order.totalPrice) {
                    return 0;
                }

                return this.order.totalPrice - this.applicableCreditAmountCents
            },
            subscriptionBagSize: function () {
                // if (this.orderPreferences.size === '12oz') {
                //     return '10oz 12oz';
                // }
                // return '5lb';
                var text = this.orderPreferences.size.toString();
                return text;
            }
        },
        mounted(){
            this.sizeCategory = this.customSizes.filter(r => r.imperial_uom === this.order.size)[0].size_category;
            
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-confirmation-onboarding {
        text-align: center;
        padding: 1rem 2rem 2rem 2rem;
        p {
            line-height: normal;
        }
    }
    .order-preferences {
        display: inline-flex;
        text-align: center;
        justify-content: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
    }

    .order-preference {
        align-items: center;
        display: flex;
        flex-flow: wrap;
    }
    

    .order-preference {
        padding: 0 1rem;
        border-right: solid 1px $color-primary;
        align-items: center;
        align-items: center;
        display: flex;
        flex-flow: wrap;
        max-width: 60px;
    }

.order-preference-size .order-preference:only-child {
    min-width: auto;
}
    .order-preference-last {
        @extend .order-preference;
        border: none;
    }
    .confirmation-content-wrapper {
        padding-left: 2rem;
        padding-right: 2rem;
        margin-bottom: 2rem;
        font-size: 18px;
        p {
            margin: 0;
        }
    }
    .coffee-name-sm {
        margin: 0;
        font-size: 18px;
    }
    .coffee-name-lg {
        color: $color-primary;
        margin-bottom: 2rem;
        line-height: 1.2;
    }
    .total-price {
        color: $green-primary;
        margin-top: 0;
    }
    .spinner {
        font-size: 3px!important;
    }
    .order-preference-size{

        flex-wrap: wrap;
        border-right: solid 1px #455F86;
        max-width: 95px;
        display: inline-flex;
        justify-content: center;
        width: auto;
        flex: unset;
    }
    .order-preference-size .order-preference{
        border-right: none;
        padding: 0px 4px;
    }

</style>
